// 用户选择弹窗表格列配置
export const userColumns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 60,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    width: 120,
    align: 'center'
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    width: 130,
    align: 'center'
  },
];



// WEBPACK FOOTER //
// ./src/components/user-select-modal/columns.js